<ng-container *ngIf="(photoRequirement$ | async) !== undefined">
    <div *transloco="let t; read:'permit.permitPhoto.modal'" class="modal" [class.busy]="busy">
        <div class="modal__content">
            <div *ngIf="(photoRequirement$ | async) !== PhotoRequirement.Required && data.canDelete && (permitTrulyEnded$ | async) === false"
                 class="modal__content__delete">
                <div *ngIf="!deleteMode" (click)="deleteMode = true" class="modal__content__delete__anchor">{{ t("delete") }}</div>
                <ng-container *ngIf="deleteMode">
                    <div class="modal__content__delete__text">{{ t("deleteQuestion") }}</div>
                    <div class="modal__content__delete__confirm" (click)="deletePhoto(data.photo.guid)">{{ t("deleteYes") }}</div>
                    <div class="modal__content__delete__abort" (click)="deleteMode = false">{{ t("deleteNo") }}</div>
                </ng-container>
            </div>
            <img class="modal__content__photo" [src]="data.photo.url">
            <div class="modal__content__meta-data">
                <div class="modal__content__meta-data__user">{{ data.photo.author }}</div>
                <div class="modal__content__meta-data__date">{{ data.photo.uploadDate | haDate: "dateTimeStandard" }}</div>
                <div *ngIf="data.photo.step" class="modal__content__meta-data__step">{{t('stepLabel') + ' ' + t('step.' + data.photo.step) + '.' }}
                    <!-- <a *ngIf="data.photo.questionText" class="modal__content__info-link"
                        href="javascript:void(0)"
                        (mouseenter)="showTooltip($event)" (mouseleave)="hideTooltip()"
                        (click)="toggleTooltipMobile($event)"
                        tabindex="0"
                        aria-label="Visa fråga"
                    >
                        <span class="icon-circle-info-solid"></span>
                    </a> -->
                </div>
            </div>
            <!-- <div *ngIf="tooltipVisible" (click)="toggleTooltipMobile($event)" class="modal__content__tooltip">
                {{ data.photo.questionText }}
            </div> -->
            <div *ngIf="data.photo.questionText" class="modal__content__question">
                {{ data.photo.questionText }}
            </div>
        </div>

        <div class="modal__actions">
            <button class="modal__actions__close" type="button" (click)="closeModal()">{{ t("close") }}</button>
        </div>
    </div>
</ng-container>
